<template>
    <div id="app">
        <router-view v-if="isRouterAlive"></router-view>
    </div>
</template>1
<script>
    export default {
        name: 'wx',
        components: {
            
        },
        provide(){
            return{
                reload:this.reload
            }
        },
        data(){
          return {
            isRouterAlive:true,
            lang: window.location.href.indexOf('bluejeanimages')>0 ? 1 : 0,
          }
        },
        created(){
          

        },
        mounted(){
        	//this.isRunTime();
            
        },
        destroyed(){
            localStorage.removeItem('record');
            localStorage.removeItem('userInfo');
        },
        methods: {
            //刷新页面
            reload(){
                this.isRouterAlive = false;
                console.log('是否登录')
                this.$nextTick(function () {
                    this.isRouterAlive = true;
                    this.isRunTime();
                })
                
            },
            //是否登录超时
            isRunTime(){
                this.isRouterAlive = false;
                var obj=JSON.parse(localStorage.getItem('record'));
                if(!obj){
                    console.log('刷新数据')
                    this.isRouterAlive=true;
                    return false;
                }
                this.$axios.get(API.home.account).then((res)=>{
                    var res = res.data; 
                    if(res.result==1){
                        this.isRouterAlive = true;
                        this.userInfo=res.resultMsg;
                        console.log(this.userInfo)
                        localStorage.setItem('userInfo', JSON.stringify(res.resultMsg) ); 
                    }
                }).catch((err)=>{
                    localStorage.removeItem('record');
                    localStorage.removeItem('userInfo');
                    this.isRouterAlive = true;
                    console.log("请求失败") 
                })
            }

        }
      
    }; 
</script>


